import { MOB_CONFIG } from './constants/EntityConfig';
import type { MobDataConfig } from './content/generated/entities.gen';

/**
 * Re-export the generated MobDataConfig as MobConfig — it's the canonical
 * shape (declares baseDamage, attackRange, mobType, aggroRange, phases etc.)
 * and the manual MobRegistry entries below conform to it.
 *
 * Prior to this, a narrower hand-rolled MobConfig was forcing
 * `as Record<string, any>` on the MOB_CONFIG spread and
 * `(mobConfig as any).baseDamage` reads downstream — both unnecessary
 * once the type matches the actual data shape.
 */
export type MobConfig = MobDataConfig;

/**
 * MOB_REGISTRY — Centralized definitions for all NPCs and Monsters.
 * Merges manual legacy overrides with the generated MOB_CONFIG (107+ mobs).
 */
export const MOB_REGISTRY: Record<string, MobConfig> = {
  // Manual legacy overrides and custom test entities
  'training_dummy': {
    id: 'training_dummy',
    name: 'Training Dummy',
    type: 'training_dummy',
    hp: 9999,
    level: 1,
    xp: 0,
    color: '#8b4513',
    width: 60,
    height: 50,
    movementStats: {
      moveSpeed: 0,
      jumpPower: 0,
      gravityScale: 1.0,
      terminalVelocity: 1000,
      acceleration: 0,
      deceleration: 0
    }
  },

  // Spread the generated MOB_CONFIG (Source of truth from TOML)
  ...MOB_CONFIG,

 // Note: Any manual keys added below this line will override MOB_CONFIG
};

/**
 * Helper to get mob config from registry
 */
export function getMobConfig(id: string): MobConfig | undefined {
  return MOB_REGISTRY[id];
}
